import {downloadGeneratedImageAsset} from '@Components/ai-chat-window/lib/ai-chat-downloads.library';
import {sendPrompt} from '@Components/ai-chat-window/lib/ai-chat-prompt.library';
import {FileTypeOptions} from '@Components/download-panel/components/file-type-option/file-type-option.types';
import {ImageQualityOption} from '@Components/download-panel/components/ai-chat-image-download-panel-content/ai-chat-image-download-panel-content.types';
import type {ButtonAction} from '@Components/ai-chat-window/lib/chat-button-actions.types';
import {ButtonActionType, DownloadFileType, DownloadImageQuality} from '@Components/ai-chat-window/lib/chat-button-actions.types';

export const dispatchButtonAction = async (action: ButtonAction): Promise<void> => {
  switch (action.type) {
    case ButtonActionType.DOWNLOAD: {
      await downloadGeneratedImageAsset(action.chatId, action.hashedId, toQualityOption(action.imageQuality), toFileTypeOption(action.fileType));
      return;
    }
    case ButtonActionType.FILL_PROMPT: {
      sendPrompt(action.chatId, action.text);
      return;
    }
  }
};

const toFileTypeOption = (fileType: DownloadFileType): FileTypeOptions => {
  if (fileType === DownloadFileType.PDF) {
    return FileTypeOptions.PDF;
  }

  return FileTypeOptions.PNG;
};

const toQualityOption = (quality: DownloadImageQuality): ImageQualityOption => {
  if (quality === DownloadImageQuality.ENHANCED_4K) {
    return ImageQualityOption.ENHANCED_4K;
  }

  return ImageQualityOption.ORIGINAL;
};
